import { z } from 'zod';

export type SessionCustomerInfo = z.infer<typeof SessionCustomerInfo>;

export const SessionCustomerInfo = z.object({
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    name: z.string().nullish(),
    languageCode: z.string().nullish(),
    salutation: z.string().nullish(),
});
